import React from 'react';
import { Bot as _lr_Bot, Bell as _lr_Bell, Search as _lr_Search, ChevronDown as _lr_ChevronDown } from 'lucide-react';
import Avatar from './ui/Avatar';

const Bot = _lr_Bot || (() => null);
const Bell = _lr_Bell || (() => null);
const Search = _lr_Search || (() => null);
const ChevronDown = _lr_ChevronDown || (() => null);
export function Navbar() {
  return (
    <header className="sticky top-0 z-30 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 h-14 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-purple-600 flex items-center justify-center">
            <Bot size={18} className="text-white" />
          </div>
          <span className="font-bold text-gray-900 text-lg" style={{ fontFamily: 'var(--font-heading)' }}>HireBot</span>
          <span className="ml-1 text-xs bg-purple-100 text-purple-700 px-2 py-0.5 rounded-full font-medium">AI</span>
        </div>
        <div className="flex-1 max-w-sm hidden sm:block">
          <div className="relative">
            <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input placeholder="Search candidates, roles…" className="w-full pl-9 pr-4 py-2 text-sm bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-300 focus:border-purple-400" />
          </div>
        </div>
        <div className="flex items-center gap-3">
          <button className="relative p-2 rounded-lg hover:bg-gray-100 transition-colors">
            <Bell size={18} className="text-gray-500" />
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-purple-600 rounded-full" />
          </button>
          <div className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 rounded-lg px-2 py-1 transition-colors">
            <Avatar name="Rachel Green" size="sm" />
            <span className="text-sm font-medium text-gray-700 hidden sm:block">Rachel Green</span>
            <ChevronDown size={14} className="text-gray-400" />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navbar;